export class AlertConditionModel {
    constructor(
      public logicOperator?: string,
      public load?: any,
      public parameter?: string,
      public shiftwise?: string,
      public conditionOperator?: string,
      public conditionValue?: string,
      public watchWindowFromTime?: any,
      public watchWindowToTime?: any,
      public watchWindowOnDays?: any,
    ) {
    }
}
export class AlertNotificationDetailModel {
  constructor(
    public type?: any,
    public frequency?: string,
  ) {
  }
}
